import { render } from "./comex-positions.vue?vue&type=template&id=1241ed18&scoped=true"
import script from "./comex-positions.vue?vue&type=script&lang=js"
export * from "./comex-positions.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./comex-positions.vue?vue&type=style&index=1&id=1241ed18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1241ed18"]])

export default __exports__